import {styled} from "@mui/material/styles"
import {FALLBACK_FONT_FAMILY} from "@next/ux-fabric"

export const Container = styled("div")`
    align-self: center;
    flex: 1 1 auto;
    font-family: ${({theme}) =>
        `${theme.uxfabric.component.buttonMedium.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important;
    font-size: ${({theme}) => theme.uxfabric.component.buttonMedium.fontSize};
    font-weight: ${({theme}) => theme.uxfabric.component.buttonMedium.fontWeight};
    letter-spacing: ${({theme}) => theme.uxfabric.component.buttonMedium.letterSpacing}px;
    text-transform: ${({theme}) => theme.uxfabric.component.buttonMedium.textTransform};
    line-height: ${({theme}) => theme.uxfabric.component.buttonMedium.lineHeight};
    height: 2.25rem;
    min-width: 8.625rem;

    && > a {
        font-family: ${({theme}) =>
            `${theme.uxfabric.component.buttonMedium.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important;
        font-size: ${({theme}) => theme.uxfabric.component.buttonMedium.fontSize};
        font-weight: ${({theme}) => theme.uxfabric.component.buttonMedium.fontWeight};
        letter-spacing: ${({theme}) => theme.uxfabric.component.buttonMedium.letterSpacing}px;
        text-transform: ${({theme}) => theme.uxfabric.component.buttonMedium.textTransform};
        line-height: ${({theme}) => theme.uxfabric.component.buttonMedium.lineHeight};

`
